import { ref } from "vue";
import { useStore } from "vuex";
import router from "@/router";
import { EstateAppVersion } from "@/enums/EstateAppVersion";
import { UserRoles } from "@/enums/UserRoles";

export function useEstateVersionRedirect() {
  const store = useStore();
  const appVersion = ref<EstateAppVersion>();

  const checkEstateVersionAndRedirect = (
    estateId: string,
    userRole: string
  ) => {
    store
      .dispatch("estate/getEstate", estateId)
      .then((res) => {
        if (res.data && res.data.appVersion) {
          appVersion.value = res.data.appVersion;

          if (
            appVersion.value === EstateAppVersion.V2 &&
            !router.currentRoute.value.path.includes("/v2/") &&
            !router.currentRoute.value.path.includes("/admin/") &&
            (!userRole || userRole !== UserRoles.SUPER_ADMIN)
          ) {
            const currentPath = router.currentRoute.value.path;
            const currentQuery = router.currentRoute.value.query;

            const v2Path = currentPath.replace(/^\/estate\//, "/v2/estate/");

            router.replace({
              path: v2Path,
              query: currentQuery,
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching estate version:", error);
      });
  };

  return {
    appVersion,
    checkEstateVersionAndRedirect,
  };
}
